import React from "react";
import PropTypes from "prop-types";
import { Button } from "@learningblocks/shared-components";

export function ModalFooter(props) {
  const onClick = (event) => {
    event.stopPropagation();
    props.onClick();
  };
  return (
    <div className={props.className}>
      <Button disabled={props.disabled} onClick={onClick}>
        {props.text}
      </Button>
    </div>
  );
}

ModalFooter.propTypes = {
  /**
   * ClassName to set on MoalFooterBlock
   */
  className: PropTypes.string,
  /**
   * Text to display on the Modal Footer button
   */
  text: PropTypes.string,
  /**
   * Fucntion to invoke on button click
   */
  onClick: PropTypes.func,
  /**
   * Boolean to set if button is disabled
   */
  disabled: PropTypes.bool,
};

ModalFooter.defaultProps = {
  disabled: false,
};
